import * as Yup from 'yup';

const schema = Yup.object().shape({
  CustomDispName: Yup.string()
    .required('O campo Nova Disciplina não pode ser vazio'),
});

export default schema;
